import React from 'react';
import PropTypes from 'prop-types';
import StatisticButton from 'components/Managers/Dashboard/Views/Statistics/StatisticButton';

export default function AISessions({ value }) {
  return (
    <StatisticButton
      label="AI Sessions"
      value={value}
        // onClick={() => setShowModal(true)}
      className="bg-secondary-100"
    />
  );
}

AISessions.propTypes = {
  value: PropTypes.number,
};

AISessions.defaultProps = {
  value: null,
};
